

import type { EquipmentDef } from "./types";

export const EQUIPMENT_CATALOG: Record<string, EquipmentDef> = {
  thief_gloves: {
    id: "thief_gloves",
    name: "Перчатки вора",
    slot: "hands",
    statBonuses: { dexterity: 1 },
    armor: 0,
    evasionMod: 1,
    grantsCards: ["nimble_fingers"],
    description: "+1 Ловкость, +1 Уклонение. Добавляет карту «Ловкие пальцы».",
  },

  two_handed_axe: {
    id: "two_handed_axe",
    name: "Двуручный топор",
    slot: "weapon",
    statBonuses: { strength: 2 },
    armor: 0,
    evasionMod: -1,
    critBonusPct: 5,
    grantsCards: ["crushing_blow"],
    description: "+2 Сила, −1 Уклонение, +5% крит. Добавляет «Сокрушающий удар».",
  },

  heavy_plate: {
    id: "heavy_plate",
    name: "Тяжёлые латы",
    slot: "body",
    statBonuses: { constitution: 1 },
    armor: 7,
    evasionMod: -2,
    armorClass: "heavy",
    grantsCards: [],
    description: "+1 Телосложение, +7 Армор, −2 Уклонение. Тяжёлая броня.",
  },

  chain_mail: {
    id: "chain_mail",
    name: "Кольчуга",
    slot: "body",
    statBonuses: { constitution: 1 },
    armor: 4,
    evasionMod: 0,
    armorClass: "medium",
    grantsCards: [],
    description: "+1 Телосложение, +4 Армор. Средняя броня.",
  },

  leather_armor: {
    id: "leather_armor",
    name: "Кожаный доспех",
    slot: "body",
    statBonuses: { dexterity: 1 },
    armor: 2,
    evasionMod: 1,
    armorClass: "light",
    grantsCards: [],
    description: "+1 Ловкость, +2 Армор, +1 Уклонение. Лёгкая броня.",
  },

  mage_robe: {
    id: "mage_robe",
    name: "Роба мага",
    slot: "body",
    statBonuses: { intelligence: 2 },
    armor: 1,
    evasionMod: 0,
    armorClass: "light",
    grantsCards: [],
    description: "+2 Интеллект, +1 Армор. Лёгкая роба.",
  },

  leather_boots: {
    id: "leather_boots",
    name: "Кожаные сапоги",
    slot: "head",
    statBonuses: { dexterity: 1 },
    armor: 0,
    evasionMod: 1,
    grantsCards: [],
    description: "+1 Ловкость, +1 Уклонение.",
  },

  simple_sword: {
    id: "simple_sword",
    name: "Простой меч",
    slot: "weapon",
    statBonuses: { strength: 1 },
    armor: 0,
    evasionMod: 0,
    grantsCards: [],
    description: "+1 Сила. Обычный клинок.",
  },

  holy_symbol: {
    id: "holy_symbol",
    name: "Святой символ",
    slot: "accessory",
    statBonuses: { wisdom: 1 },
    armor: 0,
    evasionMod: 0,
    grantsCards: [],
    description: "+1 Мудрость.",
  },

  hunters_ring: {
    id: "hunters_ring",
    name: "Кольцо охотника",
    slot: "accessory",
    statBonuses: { dexterity: 1 },
    armor: 0,
    evasionMod: 0,
    critBonusPct: 10,
    grantsCards: [],
    description: "+1 Ловкость, +10% крит.",
  },

  blade_of_precision: {
    id: "blade_of_precision",
    name: "Клинок точности",
    slot: "weapon",
    statBonuses: { strength: 1, dexterity: 1 },
    armor: 0,
    evasionMod: 0,
    critBonusPct: 15,
    grantsCards: [],
    description: "+1 Сила, +1 Ловкость, +15% крит.",
  },
};

export function getEquipment(id: string): EquipmentDef {
  const def = EQUIPMENT_CATALOG[id];
  if (!def) throw new Error(`Unknown equipment id: ${id}`);
  return def;
}
